import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAccount, getUserSettings } from '@/api';
import { isLostBonusEnabled } from '@/domain/lost-bonuses';
import { ProfileClaimBonusPage } from './-components/ProfileClaimBonusPage';

export const Route = createFileRoute('/profile/claimbonus')({
  beforeLoad: () => {
    const account = getAccount();
    const user = getUserSettings();
    if (!isLostBonusEnabled(account, user)) {
      throw redirect({ to: '/profile' });
    }
  },
  component: ProfileClaimBonusPage,
});
